import React from 'react';
import { TypographyRoot } from './typography.styled';
import { ITypographyStyles, TOwnerState, TypographyProps } from './typography.types';
import { TYPO_LEVEL_MAP } from './typography.utils';

const Typography = <R extends keyof ITypographyStyles, V extends ITypographyStyles[R]>(
  props: TypographyProps<R, V>,
  ref?: React.Ref<HTMLHeadingElement>,
) => {
  const {
    display = 'body1',
    variant = 'default',
    align = 'inherit',
    noWrap = false,
    ...rest
  } = props;
  const ownerState: TOwnerState = {
    display,
    variant,
    align,
    noWrap,
  };

  return (
    // @ts-ignore
    <TypographyRoot
      {...rest}
      ownerState={ownerState}
      ref={ref}
      as={props.as ?? TYPO_LEVEL_MAP[display]}
    />
  );
};

export default React.forwardRef(Typography) as typeof Typography;
